export default {
  'Watermark': 'Marca de agua',
  'Add Watermark Selection': 'Agregar selección de marca de agua',
}